export default {
    small: {
        handlerSize: '24px',
    },
    medium: {
        handlerSize: '26px',
    },
    large: {
        handlerSize: '28px',
    },
};
//# sourceMappingURL=constants.js.map